(function (angular, app) {
   "use strict";

   angular.module(app.modules.ui.name)
      .service(app.modules.ui.services.branding, BrandingService);

   BrandingService.$inject = ["$q", "$location", 'siteType'
      , app.modules.common.services.storage
      , app.modules.common.services.eventbus
      , app.modules.common.constants.appsettings
      , app.modules.common.services.functions
   ];

   function BrandingService($q, $location, siteType
       , ggStorage
       , ggEvents
       , ggSettings
       , ggFunctions
      ) {

      var _Branding = function () {

         var hostName = $location.$$host;

         this.siteId = 404;
         this.clubManagementGroupId = 22;
         this.appName = "GolfNet";
         this.myAppName = "My GolfNet";
         this.myShortAppName = "MyGN";
         this.isFAQ = true;

         this.http = "https://";
         this.rootURL = "groups.golfnet.com";
         this.appURL = "golfnet://"
         this.iosURL = "https://itunes.apple.com/us/app/golfnet-golf-handicap-tracker/id571041159?mt=8";
         this.androidURL = "https://play.google.com/store/apps/details?id=air.com.MobileApp.GolfNetPro&hl=en";
         this.oneSignalId = "ddef5265-1c0f-4a49-9968-29c9077d838d"; // Used to send push notifications onesignal.com - bryan.wilson@golfnet.com / G0ldf1sh

         this.hexBody = "#202127";
         this.hexModal = "#2ED156";

         this.logo = "images/golfnet/logo.png"
         this.logoSq = "images/golfnet/logo-sq.png"
         this.promoImg = "images/golfnet/promoImg.png"

         this.navigationOptions ={
             isSlideOutMenu: true
             , isGroupyMenu: true
             , isPreferences: true
             , isOrders : true
         }

         this.scoreOutingOnDayOfOnly = false;


         this.loginPrefix = "";
         this.loginName = "UserName or Email Address";
         this.isLoginNumeric = false;
         this.isPasswordNumeric = false;
         this.isEditUserName = true;
         this.isEditPassword = true;

         this.displayText = {
             memories: "Memories"
             , outingTeeTimes : "Tee Times"
         };



         if ($location.$$search && $location.$$search.target) {
             var target = $location.$$search.target;
             var site = siteType[target];
            if (angular.isNumber(site)) {
                customSiteId = site;
            }
         }

         this.stripe = {
             live: "pk_live_CqR2xOdIIEAWFAUw4L8PLgxA"
             , test: "pk_test_A1CSn0cnKZdwylDl7HzVxcUU"
         }

         

          // USHandicap
         if ((customSiteId && customSiteId == 226) || hostName.indexOf("ushandicap") > -1) {
             this.siteId = 226;
             this.clubManagementGroupId = 22;
             this.appName = "USHandicap";
             this.myAppName = "My USHandicap";
             this.myShortAppName = "MyUSH";
             this.isFAQ = true;

             this.http = "http://";
             this.rootURL = "app.ushandicap.com";
             this.appURL = "ushandicap://"
             this.iosURL = "https://itunes.apple.com/us/app/GroupyGolf/id1154206389";
             this.androidURL = "";

             this.hexBody = "#202127";
             this.hexModal = "#04C48F";

             this.logo = "images/ush/logo.png"
             this.logoSq = "images/ush/logo-sq.png"
             this.promoImg = "images/ush/promoImg.png"

             
         }

          // Myrtle Beach
         if ((customSiteId && customSiteId == 321) || hostName.indexOf("mbwa") > -1) {
             this.siteId = 321;
             this.clubManagementGroupId = 22;
             this.appName = "Myrtle Beach World Am App";
             this.myAppName = "My MBWA";
             this.myShortAppName = "MyMBWA";
             this.isFAQ = false;

             this.http = "http://";
             this.rootURL = "mbwa.ushandicap.com";
             this.appURL = "mbwa://"
             this.iosURL = "https://itunes.apple.com/us/app/GroupyGolf/id1154206389";
             this.androidURL = "";
             this.oneSignalId = "dcbe5488-9e27-4dc2-9d49-2bc1cf764467";

             this.hexBody = "#DD0000";
             this.hexModal = "#DD0000";

             this.logo = "images/mbwa/logo.png"
             this.logoSq = "images/mbwa/logo_sq.png"
             this.promoImg = ""

             this.navigationOptions = {
                 isSlideOutMenu: false
                 , isGroupyMenu: false
                 , isPreferences: false
                 , isOrders: false
             }

             this.scoreOutingOnDayOfOnly = true;

             this.loginPrefix = "MBWA";
             this.loginName = "Player ID";
             this.isLoginNumeric = true;
             this.isPasswordNumeric = true;
             this.isEditUserName = false;
             this.isEditPassword = false;

             this.displayText.memories = "Share";
             this.displayText.outingTeeTimes = "Scoring";
         }


          // MARYLAND
         if ((customSiteId && customSiteId == 278) || hostName.indexOf("msga.golfnet.com") > -1) {
             this.siteId = 278;
             this.clubManagementGroupId = 140;
             this.appName = "MSGA";
             this.myAppName = "My MSGA";
             this.myShortAppName = "MyMSGA";
             this.isFAQ = false;

             this.http = "http://";
             this.rootURL = "msga.golfnet.com";
             this.appURL = "msga://"
             this.iosURL = "https://itunes.apple.com/us/app/GroupyGolf/id1154206389";
             this.androidURL = "";

             this.hexBody = "#202127";
             this.hexModal = "#04C48F";

             this.logo = "images/maryland/logo.png"
             this.logoSq = "images/maryland/logo-sq.png"
             this.promoImg = "images/maryland/promoImg.png"
         }

          // MONTANA
         if ((customSiteId && customSiteId == 265) || hostName.indexOf("msga.golfnet.com") > -1) {
             this.siteId = 265;
             this.clubManagementGroupId = 141;
             this.appName = "MSGA Golf";
             this.myAppName = "My MSGAGolf";
             this.myShortAppName = "MyMGAGolf";
             this.isFAQ = false;

             this.http = "http://";
             this.rootURL = "msgagolf.golfnet.com";
             this.appURL = "msgagolf://"
             this.iosURL = "https://itunes.apple.com/us/app/GroupyGolf/id1154206389";
             this.androidURL = "";

             this.hexBody = "#202127";
             this.hexModal = "#04C48F";

             this.logo = "images/montana/logo.png"
             this.logoSq = "images/montana/logo-sq.png"
             this.promoImg = "images/montana/promoImg.png"

             this.stripe = {
                 live: "pk_live_jnQG8SzxQs5zQOPKVbh2eK6E"
                , test: "pk_test_GAy2CFZY9ngj2szqqNXd1e4c"
             }

         }

          // Florida
         if ((customSiteId && customSiteId == 330) || hostName.indexOf("msga.golfnet.com") > -1) {
             this.siteId = 330;
             this.clubManagementGroupId = 142;
             this.appName = "GAF Golf";
             this.myAppName = "My GAF";
             this.myShortAppName = "MyGAF";
             this.isFAQ = false;

             this.http = "http://";
             this.rootURL = "gaf.golfnet.com";
             this.appURL = "gafgolf://"
             this.iosURL = "https://itunes.apple.com/us/app/GroupyGolf/id1154206389";
             this.androidURL = "";

             this.hexBody = "#202127";
             this.hexModal = "#04C48F";

             this.logo = "images/florida/logo.png"
             this.logoSq = "images/florida/logo-sq.png"
             this.promoImg = "images/florida/promoImg.png"
         }

      }

      

      //##//--------------------------------------- 

      this.NewBrand = function () {

         var NewBrand = new _Branding;


         return NewBrand;
      };

   }
}(angular, app));

